// @ts-nocheck
import * as Types from '../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type BusinessFunctionsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type BusinessFunctionsQuery = { __typename?: 'Query', businessFunctions: Array<{ __typename?: 'BusinessFunction', id: string, name: string, priority: number }> };

export type BusinessFunctionDetailsQueryVariables = Types.Exact<{
  businessFunctionId: Types.Scalars['ID']['input'];
}>;


export type BusinessFunctionDetailsQuery = { __typename?: 'Query', businessFunction: { __typename?: 'BusinessFunction', id: string, name: string, priority: number, autoApprovalAmountInCents?: number | null | undefined, businessFunctionType: { __typename?: 'BusinessFunctionTypeDetail', code: Types.BusinessFunctionType, name: string }, impactReviewer?: { __typename?: 'ProjectRoleDetail', code: Types.ProjectRole, name: string } | null | undefined, initialReviewer?: { __typename?: 'ProjectRoleDetail', code: Types.ProjectRole, name: string } | null | undefined, approverProjectRole?: { __typename?: 'ProjectRoleDetail', code: Types.ProjectRole, name: string } | null | undefined, applicableChangeTypes: Array<{ __typename?: 'ChangeTypeDetail', code: Types.ChangeType, name: string }> } };

export type ProjectRolesForBusinessFunctionQueryVariables = Types.Exact<{
  businessFunctionType: Types.BusinessFunctionType;
}>;


export type ProjectRolesForBusinessFunctionQuery = { __typename?: 'Query', projectRolesForBusinessFunctionType: Array<{ __typename?: 'ProjectRoleDetail', code: Types.ProjectRole, name: string, description: string }> };

export type SaveBusinessFunctionMutationVariables = Types.Exact<{
  input: Types.SaveBusinessFunctionInput;
}>;


export type SaveBusinessFunctionMutation = { __typename?: 'Mutation', saveBusinessFunction: { __typename?: 'SaveBusinessFunctionResult', businessFunction: { __typename?: 'BusinessFunction', id: string, priority: number, autoApprovalAmountInCents?: number | null | undefined, businessFunctionType: { __typename?: 'BusinessFunctionTypeDetail', code: Types.BusinessFunctionType, name: string }, impactReviewer?: { __typename?: 'ProjectRoleDetail', code: Types.ProjectRole, name: string } | null | undefined, initialReviewer?: { __typename?: 'ProjectRoleDetail', code: Types.ProjectRole, name: string } | null | undefined, approverProjectRole?: { __typename?: 'ProjectRoleDetail', code: Types.ProjectRole, name: string } | null | undefined, applicableChangeTypes: Array<{ __typename?: 'ChangeTypeDetail', code: Types.ChangeType, name: string }> } } };

export type BusinessFunctionCard_BusinessFunctionFragment = { __typename?: 'BusinessFunction', id: string, name: string, priority: number };

export type BusinessFunctionRoles_BusinessFunctionFragment = { __typename?: 'BusinessFunction', id: string, priority: number, autoApprovalAmountInCents?: number | null | undefined, businessFunctionType: { __typename?: 'BusinessFunctionTypeDetail', code: Types.BusinessFunctionType, name: string }, impactReviewer?: { __typename?: 'ProjectRoleDetail', code: Types.ProjectRole, name: string } | null | undefined, initialReviewer?: { __typename?: 'ProjectRoleDetail', code: Types.ProjectRole, name: string } | null | undefined, approverProjectRole?: { __typename?: 'ProjectRoleDetail', code: Types.ProjectRole, name: string } | null | undefined, applicableChangeTypes: Array<{ __typename?: 'ChangeTypeDetail', code: Types.ChangeType, name: string }> };

export const BusinessFunctionCard_BusinessFunctionFragmentDoc = gql`
    fragment BusinessFunctionCard_BusinessFunction on BusinessFunction {
  id
  name
  priority
}
    `;
export const BusinessFunctionRoles_BusinessFunctionFragmentDoc = gql`
    fragment BusinessFunctionRoles_BusinessFunction on BusinessFunction {
  id
  businessFunctionType {
    code
    name
  }
  priority
  impactReviewer {
    code
    name
  }
  initialReviewer {
    code
    name
  }
  autoApprovalAmountInCents
  approverProjectRole {
    code
    name
  }
  applicableChangeTypes {
    code
    name
  }
}
    `;
export const BusinessFunctionsDocument = gql`
    query BusinessFunctions {
  businessFunctions {
    ...BusinessFunctionCard_BusinessFunction
  }
}
    ${BusinessFunctionCard_BusinessFunctionFragmentDoc}`;

/**
 * __useBusinessFunctionsQuery__
 *
 * To run a query within a React component, call `useBusinessFunctionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessFunctionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessFunctionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useBusinessFunctionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BusinessFunctionsQuery, BusinessFunctionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BusinessFunctionsQuery, BusinessFunctionsQueryVariables>(BusinessFunctionsDocument, options);
      }
export function useBusinessFunctionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BusinessFunctionsQuery, BusinessFunctionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BusinessFunctionsQuery, BusinessFunctionsQueryVariables>(BusinessFunctionsDocument, options);
        }
// @ts-ignore
export function useBusinessFunctionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<BusinessFunctionsQuery, BusinessFunctionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BusinessFunctionsQuery, BusinessFunctionsQueryVariables>;
export function useBusinessFunctionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BusinessFunctionsQuery, BusinessFunctionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BusinessFunctionsQuery | undefined, BusinessFunctionsQueryVariables>;
export function useBusinessFunctionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BusinessFunctionsQuery, BusinessFunctionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BusinessFunctionsQuery, BusinessFunctionsQueryVariables>(BusinessFunctionsDocument, options);
        }
export type BusinessFunctionsQueryHookResult = ReturnType<typeof useBusinessFunctionsQuery>;
export type BusinessFunctionsLazyQueryHookResult = ReturnType<typeof useBusinessFunctionsLazyQuery>;
export type BusinessFunctionsSuspenseQueryHookResult = ReturnType<typeof useBusinessFunctionsSuspenseQuery>;
export type BusinessFunctionsQueryResult = Apollo.QueryResult<BusinessFunctionsQuery, BusinessFunctionsQueryVariables>;
export const BusinessFunctionDetailsDocument = gql`
    query BusinessFunctionDetails($businessFunctionId: ID!) {
  businessFunction(id: $businessFunctionId) {
    id
    name
    ...BusinessFunctionRoles_BusinessFunction
  }
}
    ${BusinessFunctionRoles_BusinessFunctionFragmentDoc}`;

/**
 * __useBusinessFunctionDetailsQuery__
 *
 * To run a query within a React component, call `useBusinessFunctionDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessFunctionDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessFunctionDetailsQuery({
 *   variables: {
 *      businessFunctionId: // value for 'businessFunctionId'
 *   },
 * });
 */
export function useBusinessFunctionDetailsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BusinessFunctionDetailsQuery, BusinessFunctionDetailsQueryVariables> & ({ variables: BusinessFunctionDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BusinessFunctionDetailsQuery, BusinessFunctionDetailsQueryVariables>(BusinessFunctionDetailsDocument, options);
      }
export function useBusinessFunctionDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BusinessFunctionDetailsQuery, BusinessFunctionDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BusinessFunctionDetailsQuery, BusinessFunctionDetailsQueryVariables>(BusinessFunctionDetailsDocument, options);
        }
// @ts-ignore
export function useBusinessFunctionDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<BusinessFunctionDetailsQuery, BusinessFunctionDetailsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BusinessFunctionDetailsQuery, BusinessFunctionDetailsQueryVariables>;
export function useBusinessFunctionDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BusinessFunctionDetailsQuery, BusinessFunctionDetailsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BusinessFunctionDetailsQuery | undefined, BusinessFunctionDetailsQueryVariables>;
export function useBusinessFunctionDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BusinessFunctionDetailsQuery, BusinessFunctionDetailsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BusinessFunctionDetailsQuery, BusinessFunctionDetailsQueryVariables>(BusinessFunctionDetailsDocument, options);
        }
export type BusinessFunctionDetailsQueryHookResult = ReturnType<typeof useBusinessFunctionDetailsQuery>;
export type BusinessFunctionDetailsLazyQueryHookResult = ReturnType<typeof useBusinessFunctionDetailsLazyQuery>;
export type BusinessFunctionDetailsSuspenseQueryHookResult = ReturnType<typeof useBusinessFunctionDetailsSuspenseQuery>;
export type BusinessFunctionDetailsQueryResult = Apollo.QueryResult<BusinessFunctionDetailsQuery, BusinessFunctionDetailsQueryVariables>;
export const ProjectRolesForBusinessFunctionDocument = gql`
    query ProjectRolesForBusinessFunction($businessFunctionType: BusinessFunctionType!) {
  projectRolesForBusinessFunctionType(businessFunctionType: $businessFunctionType) {
    code
    name
    description
  }
}
    `;

/**
 * __useProjectRolesForBusinessFunctionQuery__
 *
 * To run a query within a React component, call `useProjectRolesForBusinessFunctionQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectRolesForBusinessFunctionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectRolesForBusinessFunctionQuery({
 *   variables: {
 *      businessFunctionType: // value for 'businessFunctionType'
 *   },
 * });
 */
export function useProjectRolesForBusinessFunctionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectRolesForBusinessFunctionQuery, ProjectRolesForBusinessFunctionQueryVariables> & ({ variables: ProjectRolesForBusinessFunctionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectRolesForBusinessFunctionQuery, ProjectRolesForBusinessFunctionQueryVariables>(ProjectRolesForBusinessFunctionDocument, options);
      }
export function useProjectRolesForBusinessFunctionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectRolesForBusinessFunctionQuery, ProjectRolesForBusinessFunctionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectRolesForBusinessFunctionQuery, ProjectRolesForBusinessFunctionQueryVariables>(ProjectRolesForBusinessFunctionDocument, options);
        }
// @ts-ignore
export function useProjectRolesForBusinessFunctionSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectRolesForBusinessFunctionQuery, ProjectRolesForBusinessFunctionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectRolesForBusinessFunctionQuery, ProjectRolesForBusinessFunctionQueryVariables>;
export function useProjectRolesForBusinessFunctionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectRolesForBusinessFunctionQuery, ProjectRolesForBusinessFunctionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectRolesForBusinessFunctionQuery | undefined, ProjectRolesForBusinessFunctionQueryVariables>;
export function useProjectRolesForBusinessFunctionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectRolesForBusinessFunctionQuery, ProjectRolesForBusinessFunctionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectRolesForBusinessFunctionQuery, ProjectRolesForBusinessFunctionQueryVariables>(ProjectRolesForBusinessFunctionDocument, options);
        }
export type ProjectRolesForBusinessFunctionQueryHookResult = ReturnType<typeof useProjectRolesForBusinessFunctionQuery>;
export type ProjectRolesForBusinessFunctionLazyQueryHookResult = ReturnType<typeof useProjectRolesForBusinessFunctionLazyQuery>;
export type ProjectRolesForBusinessFunctionSuspenseQueryHookResult = ReturnType<typeof useProjectRolesForBusinessFunctionSuspenseQuery>;
export type ProjectRolesForBusinessFunctionQueryResult = Apollo.QueryResult<ProjectRolesForBusinessFunctionQuery, ProjectRolesForBusinessFunctionQueryVariables>;
export const SaveBusinessFunctionDocument = gql`
    mutation SaveBusinessFunction($input: SaveBusinessFunctionInput!) {
  saveBusinessFunction(input: $input) {
    businessFunction {
      ...BusinessFunctionRoles_BusinessFunction
    }
  }
}
    ${BusinessFunctionRoles_BusinessFunctionFragmentDoc}`;
export type SaveBusinessFunctionMutationFn = Apollo.MutationFunction<SaveBusinessFunctionMutation, SaveBusinessFunctionMutationVariables>;

/**
 * __useSaveBusinessFunctionMutation__
 *
 * To run a mutation, you first call `useSaveBusinessFunctionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveBusinessFunctionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveBusinessFunctionMutation, { data, loading, error }] = useSaveBusinessFunctionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveBusinessFunctionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveBusinessFunctionMutation, SaveBusinessFunctionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveBusinessFunctionMutation, SaveBusinessFunctionMutationVariables>(SaveBusinessFunctionDocument, options);
      }
export type SaveBusinessFunctionMutationHookResult = ReturnType<typeof useSaveBusinessFunctionMutation>;
export type SaveBusinessFunctionMutationResult = Apollo.MutationResult<SaveBusinessFunctionMutation>;
export type SaveBusinessFunctionMutationOptions = Apollo.BaseMutationOptions<SaveBusinessFunctionMutation, SaveBusinessFunctionMutationVariables>;